// The ShellContext — provides the cross-cutting shell view-state (chat/toast/modal machine) to the topbar
// launcher, the chat dock, the modal mounts, and the toast without prop-drilling through every surface. The
// value is the ShellState the App root constructs (useShellState); descendants read it via useShell().

import { createContext, useContext } from 'react';
import type { ShellState } from './shell-state.ts';

const ShellContext = createContext<ShellState | null>(null);

export const ShellProvider = ShellContext.Provider;

/** Optional read for reusable leaf views that are also rendered in isolated component tests. */
export function useOptionalShell(): ShellState | null {
  return useContext(ShellContext);
}

/** Read the shell view-state. Throws if used outside the provider (a wiring bug, surfaced honestly). */
export function useShell(): ShellState {
  const value = useOptionalShell();
  if (value === null) {
    throw new Error('useShell must be used within the ShellProvider (App root)');
  }
  return value;
}
